module.exports = __webpack_public_path__ + "assets/img/组 193@2x.14670a55.png";